import {
    dismissCharmSuggestions,
    showCharmSuggestions,
    setCharmSuggestions,
} from 'owa-calendar-compose-form-actions';
import { mutator } from 'satcheljs';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';

/**
 * Dismisses the charm suggestions
 */
mutator(dismissCharmSuggestions, actionMessage => {
    const composeViewState = getComposeViewState(actionMessage.formId);
    if (composeViewState?.charmSuggestionsViewState) {
        composeViewState.charmSuggestionsViewState.shouldShowSuggestions = false;
    }
});

/**
 * Updates the charm in the calendar event
 */
mutator(showCharmSuggestions, actionMessage => {
    const composeViewState = getComposeViewState(actionMessage.formId);
    if (composeViewState?.charmSuggestionsViewState) {
        composeViewState.charmSuggestionsViewState.shouldShowSuggestions = true;
    }
});

/**
 * Updates the value of the charm suggestions
 */
mutator(setCharmSuggestions, actionMessage => {
    const { suggestions, formId } = actionMessage;
    const composeViewState = getComposeViewState(formId);
    if (composeViewState?.charmSuggestionsViewState) {
        composeViewState.charmSuggestionsViewState.suggestions = suggestions;
    }
});
